import { Box, type Sx } from '@mantine/core';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  sx?: Sx;
};

export const LayoutMain = ({ children, sx }: Props) => {
  return (
    <Box
      sx={[
        theme => ({
          flex: '0 0 100%',
          order: 2,
          borderBottom: `1px solid ${theme.colors.gray[1]}`,
          [`@media (min-width: ${theme.breakpoints.sm}px)`]: {
            flex: 1,
            order: 1,
            height: 'auto',
            borderRight: `1px solid ${theme.colors.gray[1]}`,
            borderBottom: 'none',
          },
        }),
        sx,
      ]}
    >
      {children}
    </Box>
  );
};
